var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53076 16.2291C9.53076 16.2291 5.13778 17.9375 4.40576 23.9166M33.4474 16.2291C33.4474 16.2291 37.8404 17.9375 38.5724 23.9166M16.3641 16.2291C16.3641 16.2291 20.4641 17.2259 21.4891 22.2083C22.5141 17.2259 26.6141 16.2291 26.6141 16.2291M18.0724 29.0416C18.0724 29.0416 14.4849 29.6823 12.9474 34.1666M24.9058 29.0416C24.9058 29.0416 28.4933 29.6823 30.0308 34.1666",
    stroke: "white",
    strokeWidth: 1.31,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4891 30.75C23.8478 30.75 25.7599 28.8379 25.7599 26.4791C25.7599 24.1204 23.8478 22.2083 21.4891 22.2083C19.1304 22.2083 17.2183 24.1204 17.2183 26.4791C17.2183 28.8379 19.1304 30.75 21.4891 30.75Z",
    stroke: "white",
    strokeWidth: 1.31,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0308 17.0833C32.8612 17.0833 35.1558 14.7888 35.1558 11.9583C35.1558 9.12785 32.8612 6.83331 30.0308 6.83331C27.2003 6.83331 24.9058 9.12785 24.9058 11.9583C24.9058 14.7888 27.2003 17.0833 30.0308 17.0833Z",
    stroke: "white",
    strokeWidth: 1.31,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9473 17.0833C15.7777 17.0833 18.0723 14.7888 18.0723 11.9583C18.0723 9.12785 15.7777 6.83331 12.9473 6.83331C10.1168 6.83331 7.82227 9.12785 7.82227 11.9583C7.82227 14.7888 10.1168 17.0833 12.9473 17.0833Z",
    stroke: "white",
    strokeWidth: 1.31,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyIcon);
export default __webpack_public_path__ + "static/media/family-icon.ba3d7b082046bb29bde63288f8243e5f.svg";
export { ForwardRef as ReactComponent };